import { useTheme } from 'styled-components'

import { FlexColumn } from '@/@bothrs-ui/web/components/layout'
import { Span } from '@/@bothrs-ui/web/components/typography/Body'

import type { QuestionAnswerOption } from '@healthblocks-io/core'

type MultiSelectAnswerProps = {
  /**
   * The title of the question
   */
  title: string

  /**
   * The description of the question
   */
  description: string

  /**
   * The answer options
   */
  answerOptions: QuestionAnswerOption[]

  /**
   * The values of the answers
   */
  answers: string[]
}

export const MultiSelectAnswer = ({ title, description, answers, answerOptions }: MultiSelectAnswerProps) => {
  const theme = useTheme()

  const mappedAnswers = answers.map((answer) => {
    const answerOption = answerOptions.find((option) => option.value === answer)
    return answerOption?.label ?? answer
  })

  return (
    <FlexColumn gap={theme.UI.Spacing.Space2}>
      <Span type='BodyMediumBold' color={theme.Colors.Neutrals.Darkest}>
        {`${title && description ? `${title}: ` : title || ''}${description}`}
      </Span>
      <ul style={{ listStyle: 'initial', paddingLeft: theme.UI.Spacing.Space4 }}>
        {mappedAnswers.map((item: string) => (
          <li key={item} color={theme.Colors.Neutrals.Darker}>
            {item}
          </li>
        ))}
      </ul>
    </FlexColumn>
  )
}
